import { observer, inject } from "mobx-react";
import { Outlet } from "react-router-dom";
import DateRangePicker from "../UI/DateRangePicker";
import { Text } from "../UI";
import { SearchInput } from "../UI/Input";

const SearchHeader = ({ title, handleDateChange, handleSearchChange }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-start",
          gap: "0.5em",
          alignItems: "center",
        }}>
        <Text.H1 style={{ textAlign: "start" }} color="#4A69A6">
          {title}
        </Text.H1>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}>
          <SearchInput handleSearchChange={handleSearchChange} />
          <DateRangePicker
            handleDateChange={handleDateChange}></DateRangePicker>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default inject()(observer(SearchHeader));
